import { Company } from '../companies/company.model';
import { Note } from '../../shared/notes/note.model';
import { ProjectProgress } from './components/project-steps/project-step.model';
import { BooleanDate } from '../../shared/models/boolean-date.model';
import { TeamMember } from '../team/team.model';
import { Task } from '../../shared/tasks/task.model';
import { Communication } from '../../shared/communications/communication.model';
import { EventBB } from '../events/event.model';
import { Payment } from '../../shared/payments/payment.model';
import { Clinic } from '../../shared/clinics/clinic.model';
import { Attachment } from '../../shared/attachments/attachment.model';


export class Project {

  _id?: string;
  reference: number;

  /* basic project info */
  projectName: string;
  client: Company;
  status: string;
  description: string;

  /* both */
  retainerAmount?: number;
  expectedPrice?: number;
  expectedFee?: number;
  expectedCompletion: Date = new Date();
  keyFeeTerms: string;

  /* opportunity */
  opportunityStatus: string = 'Introduction';
  serviceOfInterest: string = 'Sale';
  velocityProducts: string[] = [];
  lostOpportunityReason: string = '';
  lostOpportunityDescription: string = '';
  dateClientSigned: Date = new Date();
  introductionDate: Date = new Date();
  initialMeetingDate: Date = new Date();

  /* deal */
  isDeal: boolean = false;
  dealStatus: string = 'Signed But Nothing Started';
  moneyLaunderingChecklistSent: BooleanDate = new BooleanDate();
  moneyLaunderingInformationReceived: BooleanDate = new BooleanDate();

  /* list of the contacts involved in the project */
  blueboxContacts: TeamMember[] = [];

  /* for logging the status of the project */
  currentStatus: string;
  currentStatusId: number = 0;

  /* list of steps/buyers */
  projectProgress: ProjectProgress[];

  // tags: [String],
  payments: Payment[];
  clinics: Clinic[];
  communications: Communication[];
  event: EventBB;
  tasks: Task[] = [];
  attachments: Attachment[] = [];
  notes: Note[] = [];


  constructor() { }

  setProjectColor() {

    switch (+this.status) {
      case ProjectStatus.AwaitingPitch || ProjectStatus.PitchHeld: return 'badge-secondary';
      case ProjectStatus.BlueDiamond: return 'badge-primary';
      case ProjectStatus.Completed: return 'badge-success';
      case ProjectStatus.DeferredDeal: return 'badge-warning';
      case ProjectStatus.DeadDeal: return 'badge-danger';
      default: return 'badge-info';
    }
  }

}

export enum ProjectStatus {
  AwaitingPitch = 1,
  PitchHeld,
  SignedClient,
  BlueDiamond,
  PreparingDocs,
  ApproachingPurchasers,
  CompletedApproaches,
  DealsAtHeads,
  Completed,
  DeferredDeal,
  DeadDeal,
}

export enum ProjectServiceType {
  Sale = 1,
  FundRaise,
  // Velocity,
  // BlueDiamond,
  Renewables,
  Infrastructure,
  OtherAdvisory,
  MAndA,
  EquityRaise,
  DebtRaise,
  Tax,
  Other,
}

export enum OpportunityLostReason {
  Price = 1,
  Competition,
  Other,
}

export enum VelocityProducts {
  BuyABusinessClassicPackage = 1,
  BuyABusinessPremiumPackage,
  BuyABusinessUltimatePackage,
  SellABusinessClassicPackage,
  SellABusinessPremiumPackage,
  SellABusinessUltimatePackage,
  RaiseFundsClassicPackage,
  RaiseFundsPremiumPackage,
  RaiseFundsUltimatePackage,
  Spotlight,
  SuiteOfTemplates,
  ValueMyBusiness,
  ValuationSupport,
  LegalReview,
  HRReview,
  TailoredApproachCorrespondence,
  TaxReview,
  ElectronicDataRoom,
  FinancialModel,
  MiniProspectus,
  SolvencyReview,
  Prospectus,
  Listof20TargetInvestors,
  Listof20AcquisitionTargets,
  Listof20TargetBuyers,
  OnlinePromotion,
  HealthCheck,
  OutboundApproachesX20,
  MonthlySupport,
  PreprocessStructuring,
  OutboundApproachesX40,
  TailoredInformationMemorandum,
  DebtReview,
  MonthlySubscriptionAcquisitionTargets,
  Launchpad,
  PullYourStoryTogether,
  ArtOfThePossible
}

// Opportunity Status
export enum OpportunityStatus {
  Introduction = 1,
  TryingToOrganiseAMeeting,
  MeetingBooked,
  InitialMeetingHeld,
  FormalPitchBooked,
  ProposalRequested,
  ProposalSent,
  NegotiatingClosing,
  AwaitingSignature,
  ClosedWon,
  ClosedLost,
  DeclinedToBid,
  ForTheFuture,
  DidNotRespondToCalls,
}



// Deal Status
export enum DealStatus {
  DealExchangedAndAwaitingConfirmation = 1,
  DealsAtHeadsAndDueDilligence,
  CompletedApproachingPurchasers,
  CurrentlyApproachingPotentialPurchasers,
  PreparingSaleDocuments,
  BlueDiamondOnGoingProcess,
  SignedButNothingStarted,
  Deferred,
  Dead,
  CompletedMandate,
  ProductPurchased,
  AwaitingFactFindCompletion,
  PreparingDeliverables,
  CompletedOrder,
  AwaitingClosing,
  SPAInvestmentDocsSigned,
  NeogiatingSaleInvestmentterms,
  PurchaserInvestorDueDiligance, 
  ApproachingPurchasersInvestors,
  PreparingIMTeaserDocs,
  LOESentToClient 
}



// WEBPACK FOOTER //
// ./client/app/features/projects/project.model.ts